import { OFFER_DETAILS_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';

export const getPromoProducts = (state) => {
  return state[OFFER_DETAILS_REDUCER_KEY]?.products;
};

export const getCurrentCurrency = (state) => {
  return state?.session?.siteDetails?.currency;
};

export const getPromotionsDetails = (state) => {
  return state?.Promotions?.promotionsDetails;
};

